import { boot } from 'quasar/wrappers';
import HeaderProfile from '@app/shared/src/components/header/Profile.vue';
import { RegisterUIKit } from 'SharedDir/common/ui-kit';
import SPageHeader from 'PortalDir/components/page/SPageHeader.vue';
import SPage from 'PortalDir/components/page/SPage.vue';
import SImg from 'PortalDir/components/SImg.vue';

export default boot(async ({ app }) => {
  RegisterUIKit(app);

  app.component('HeaderProfile', HeaderProfile);
  app.component('SPageHeader', SPageHeader);
  app.component('SPage', SPage);
  app.component('SImg', SImg);
});
